import HttpService from "./http.service";

class AuthService {
  login = async (payload) => {
    return await HttpService.post('login', payload);
  };

  logout = async () => {
    return await HttpService.post('logout');
  };

  settings = async () => {
    return await HttpService.get('settings');
  };

  //Wallets
  fetchWallets = async () => {
    return await HttpService.get(`wallets`);
  };

  createWallet = async (payload) => {
    return await HttpService.post('wallets', payload);
  };

  updateWallet = async (id, payload) => {
    return await HttpService.put(`wallets/${id}`, payload);
  };

  deleteWallet = async (id) => {
    return await HttpService.delete(`wallets/${id}`);
  };

  setActiveWallet = async (id) => {
    return await HttpService.post(`wallets/${id}/active`);
  };

  //Accounts
  fetchAccounts = async () => {
    return await HttpService.get('accounts');
  };

  createAccount = async (payload) => {
    return await HttpService.post('accounts', payload);
  };

  updateAccount = async (id, payload) => {
    return await HttpService.put(`accounts/${id}`, payload);
  };

  deleteAccount = async (id) => {
    return await HttpService.delete(`accounts/${id}`);
  };

  //Transactions
  fetchTransactions = async (payload) => {
    return await HttpService.get('transactions', payload);
  };

  createTransaction = async (payload) => {
    return await HttpService.post('transactions', payload);
  };

  updateTransaction = async (id, payload) => {
    return await HttpService.put(`transactions/${id}`, payload);
  };

  deleteTransaction = async (id) => {
    return await HttpService.delete(`transactions/${id}`);
  };

  fetchTotalTransactions = async (payload) => {
    return await HttpService.get('transactions/total', payload);
  };
  
  //Utils
  getEnums = async (enumName) => {
    return await HttpService.get(`utils/enums/${enumName}`);
  };

  //Summaries
  fetchSummaries = async (type, payload) => {
    return await HttpService.get(`summaries/${type}`, payload);
  };

  fetchSummariesTotal = async (type, payload) => {
    return await HttpService.get(`summaries/${type}/total`, payload);
  };

  summariesCalculate = async (payload) => {
    return await HttpService.post(`summaries/calculate`, payload);
  };
}

export default new AuthService();
